<template>
  <button class="c-button" type="button" :class="[color,{ 'disabled': disabled}]" v-on:click.prevent="onClick">{{text}}</button>
</template>

<script>
export default {
  name: 'CButton',
  props: {
    text: String,
    color: String,
    disabled: {
      type: Boolean,
      default: false
    },
    additionStile: Object,
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    onClick: function (event){
      if(!this.disabled){
        this.$emit('click');
      }
    }
  }
}
</script>